import { useSelector } from "react-redux";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { ColorIndicator } from "../../components/colorIndicator";
import { GRAPH_UNITS } from "../../pages/dashboard/constants";
import { getLabel, currencyFormatter, nKilowattFormatter, nFormatter } from "../../services/utils";

const useStyles = makeStyles(() => ({
  name: {
    "&:first-letter": {
      textTransform: "capitalize",
    },
  },
}));

export const PieLegends = ({ data, colors, unit = undefined, xs = 3, marginBottom = 12 }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  unit = unit ?? currencySymbol;

  const getLegendValue = (value) => {
    switch (unit) {
      case GRAPH_UNITS.kwh:
        return nKilowattFormatter(value);
      case GRAPH_UNITS.tonCarbon:
        return `${nFormatter(value)} tCO2`;
      case GRAPH_UNITS.nFormatter:
        return nFormatter(value);
      default:
        return currencyFormatter(value, currencySymbol);
    }
  };

  return (
    <Box sx={{ margin: "0 10px" }}>
      {data.map((entry, index) => (
        <Grid key={index} container justifyContent="center" style={{ marginBottom: marginBottom }}>
          <Grid item xs={xs}>
            <Grid container alignItems="center">
              <ColorIndicator color={colors[entry.key]} />
              <Typography className={classes.name} variant="body2">
                {getLabel(entry.key)}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" align="right">
              {getLegendValue(entry.legendValue)}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};
